import * as React from "react";
export function SampleDefTable({ data, dataset }) {
    const buildRows = React.useCallback(() => {
        data.forEach(e => console.log(e));
        const rows = data.map((record, index, array) => {
            return (React.createElement("tr", { key: record.key },
                React.createElement("td", null, index + 1),
                React.createElement(Cell, { index: index, value: record.value, edit: true, updateData: dataset.update.bind(dataset) }),
                React.createElement("td", null,
                    React.createElement("button", { className: "cross", onClick: e => dataset.remove(index) }, "x"))));
        });
        rows.push(React.createElement("tr", { key: Date.now() },
            React.createElement("td", null),
            React.createElement(Cell, { index: data.length, value: '', edit: true, updateData: dataset.update.bind(dataset) })));
        return rows;
    }, [data]);
    return (React.createElement("table", null,
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null,
                    React.createElement("var", null, "i")),
                React.createElement("th", null,
                    React.createElement("var", null,
                        "x",
                        React.createElement("sub", null, "i"))))),
        React.createElement("tbody", null, buildRows())));
}
// alt pass in the entire dataset
export function Cell({ index, value, edit, updateData }) {
    const val = React.useRef(value.toString());
    const onSubmit = React.useCallback((e) => {
        e.preventDefault();
        if (val.current.trim() === '') {
            return;
        }
        let c = Number(val.current);
        // console.log(index, c);
        if (isNaN(c)) {
            return;
        }
        updateData(index, c);
    }, []);
    if (!edit) {
        return (React.createElement("td", null, value));
    }
    return (React.createElement("td", null,
        React.createElement("form", { onSubmit: onSubmit },
            React.createElement("input", { pattern: "\\d+(\\.\\d+)?", defaultValue: value, onChange: e => { val.current = e.target.value; }, onBlur: onSubmit }))));
}
//# sourceMappingURL=SampleDefTable.js.map